import React, { ReactNode, useState } from 'react';
import { Chevron } from '@tink/core/src/components/atoms/Icons/Chevron';
import { DetailsBody, StyledAccordionDetails, StyledSummary } from './Accordion.styles';

export type AccordionProps = {
  heading: ReactNode;
  onToggle?: (name: string) => void;
  /**
   * Name used to identify the interaction in analytics
   * */
  name: string;
};

export const Accordion: React.FC<AccordionProps> = ({ children, heading, onToggle, name }) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(!open);

    if (onToggle) {
      onToggle(name);
    }
  };

  return (
    <StyledAccordionDetails onToggle={handleToggle}>
      <StyledSummary>
        {heading} <Chevron direction={open ? 'up' : 'down'} />
      </StyledSummary>
      <DetailsBody>{children}</DetailsBody>
    </StyledAccordionDetails>
  );
};
